module.exports = __webpack_public_path__ + "static/media/en.0eb3abb3.svg";